import React, { ReactNode, Fragment } from "react";

export function Mount(props: MountProps) {
    if (!props.if) return null;

    return <Fragment>{props.children}</Fragment>;
}

export type MountProps = {
    if: boolean,
    children: ReactNode
};
